<template>
  <b-card>
    <b-card>
      <div class="filters-inline">
        <b-form-select
          class="filter-select"
          v-model="selectedYear"
          :options="yearOptions"
          :disabled="isLoading"
        />

        <b-form-select
          class="filter-select"
          v-model="selectedMonth"
          :options="monthOptions"
          :disabled="isLoading"
        />

        <b-button
          variant="primary"
          class="filter-button"
          @click="sendRequest"
          :disabled="isLoading"
        >
          <span v-if="isLoading">
            <b-spinner small class="mr-1" />
            Atualizando
          </span>
          <span v-else> 
            Atualizar valores 
            </span>
        </b-button>
      </div>
    </b-card>


  </b-card>
</template>

<script>
import { BContainer, BCard, BForm, BRow, BCol, BButton, BFormSelect, BAlert, BSpinner,} from "bootstrap-vue";
import GatewayExpenseService from "@/service/gateway-expense";

export default {
  components: {
    BContainer,
    BCard,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormSelect,
    BAlert,
    BSpinner,
  },
  data() {
    return {
      selectedYear: null,
      selectedMonth: null,
      isLoading: false,

      yearOptions: [
        { value: null, text: "Ano" },
        { value: 2025, text: "2025" },
        { value: 2026, text: "2026" },
      ],

      monthOptions: [
        { value: null, text: "Mês" },
        { value: "01", text: "Janeiro" },
        { value: "02", text: "Fevereiro" },
        { value: "03", text: "Março" },
        { value: "04", text: "Abril" },
        { value: "05", text: "Maio" },
        { value: "06", text: "Junho" },
        { value: "07", text: "Julho" },
        { value: "08", text: "Agosto" },
        { value: "09", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" },
      ],
    };
  },
  watch: {
  selectedMonth() { this.emitFilter(); },
  selectedYear() { this.emitFilter(); }
},
  methods: {
  emitFilter() {
      if (this.selectedYear && this.selectedMonth) {
        this.$emit("filter-changed", `${this.selectedYear}-${this.selectedMonth}`);
      } 
 
      else {
        this.$emit("filter-changed", null);
      }
    },
    
  async sendRequest() {
      if (!this.selectedYear || !this.selectedMonth) {
        this.modal("Escolha o mês e o ano que deseja atualizar");
        return;
      }

      this.isLoading = true;
      try {
        const dateForBackend = `${this.selectedYear}-${this.selectedMonth}-01`;
        const dateForFilter = `${this.selectedYear}-${this.selectedMonth}`;
        await GatewayExpenseService.saveExpense({ date: dateForBackend });

         this.modal("Dados atualizados com sucesso");
  

        this.$emit("filter-changed", dateForFilter);
      } catch (error) {
        console.error("Erro ao atualizar gastos:", error);
        alert("Erro ao atualizar valores");
      } finally {
        this.isLoading = false;
      }
    }

  },
};
</script>

<style >
.filters-inline {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.filter-select {
  min-width: 220px;
  max-width: 25%;
}

.filter-button {
  white-space: nowrap;
  max-width: 30%;
  min-width: 10%;
}

</style>